<!--产品分类-->
<template>
    <div>
        <!--顶部搜索 按钮-->
        <el-row :gutter="20">
            <el-col :span="3">
                <el-input :size="size" placeholder="请输入产品分类名称" v-model="queryInfo.name" clearable ></el-input>
            </el-col>
            <el-col :span="2">
                <el-button :size="size" v-permission="['SYS-PROJECT-CATEGORY-PAGE']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            </el-col>
            <el-col :span="19" style="text-align: right;">
                <el-button :size="size" v-permission="['SYS-PROJECT-CATEGORY-ADD']" type="primary" icon="el-icon-plus" @click="showAddDialog">添加分类</el-button>
            </el-col>
        </el-row>
        <!--内容展示-->
        <el-row style="margin-top: 20px;">
            <!--树形表格-->
            <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist">
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                        <template slot-scope="scope">
                            <el-button v-permission="['SYS-PROJECT-CATEGORY-UPDATE']" type="primary" size="mini" icon="el-icon-edit" round @click="showEditDialog(scope.row)">编辑</el-button>
                            <el-button v-permission="['SYS-PROJECT-CATEGORY-DELETE']" type="danger" size="mini" icon="el-icon-delete" round @click="deleteEditDialog(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='parent'">
                        <template slot-scope="scope">
                            <span>{{getParentNode(categoryTree,scope.row.parent).name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <!--分页区域-->
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <el-dialog :title="titleForm"
                   width="30%"
                   @close="handleClose"
                   :visible.sync="editDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true">
            <el-form :model="editItem" :rules="formRules" ref="editFormRef" label-width="80px">
                <el-row >
                    <el-form-item label="名称：" prop="name">
                        <el-input v-model="editItem.name"></el-input>
                    </el-form-item>
                </el-row>
                <el-row >
                    <el-form-item label="代码：" prop="code">
                        <el-input v-model="editItem.code"></el-input>
                    </el-form-item>
                </el-row>
                <el-row >
                    <el-form-item label="上级：" prop="parent">
                        <CategoryCascade v-model="editItem.parent" @nodeChange="nodeCategoryCascader"></CategoryCascade>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="editFun">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/pagination/index'
import CategoryCascade from '@/components/category/Cascader'
import {
    categoryProductPage,
    delCategoryProduct,
    updateCategoryProduct,
    addCategoryProduct,
    categoryProductTree
} from '@/api/product'

export default {
    name: 'PRODUCT-CATEGORY',
    components: {
        Pagination, CategoryCascade
    },
    data() {
        return {
            tablelist: [],
            columns: [
                {
                    label: '名称',
                    prop: 'name',
                    width: '280px'
                },{
                    label: '编码',
                    prop: 'code'
                },{
                    label: '上级',
                    type: 'template',
                    prop: 'parent'
                },{
                    label: '创建时间',
                    prop: 'createTime'
                },{
                    label: '操作',
                    type: 'template',
                    prop: 'action',
                    width: '330px'
                }
            ],
            queryInfo: {
                pagesize: 10,
                pagenum: 1,
                name: ''
            },
            total: 0,
            editItem: {
                name: '',
                code: '',
                parent: 0
            },
            titleForm: '添加产品分类',
            editDialogVisible: false,
            categoryTree: [],
            size:this.COMMON.size,
            treeTableHeight: 650,
            loading: true
        }
    },
    methods: {
        // 关闭添加
        handleClose() {
            this.$nextTick(() => {
                this.editItem = {
                    name: '',
                    code: ''
                } // 给表单赋值
            })
            this.$refs.editFormRef.resetFields()
            console.log('执行重置')
            this.editDialogVisible = false
        },
        getCategoryList() {
            if(this.queryInfo.name!=undefined) {
                this.queryInfo.name = this.queryInfo.name.trim()
            }
            let param = {}
            param.current = this.queryInfo.pagenum
            param.size = this.queryInfo.pagesize
            this.loading = true
            categoryProductPage(param,this.queryInfo).then(response=>{
                if(response.code!=200)
                    return this.$message.error('获取产品分类失败！')
                console.log('获取产品分类分页结果',response)
                this.tablelist = response.data.records
                this.total = response.data.total
                this.getHeight()
                this.loading = false
            })
        },
        /**
         * 分页组件切换分页大小事件处理
         * @param newSize
         */
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize
            this.getCategoryList()
        },
        /**
         * 分页组件切换页事件处理
         * @param newPage
         */
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage
            this.getCategoryList()
        },
        // 展示用户添加
        showAddDialog(){
            console.log('添加产品分类')
            this.titleForm = '添加产品分类'
            this.editDialogVisible = true
        },
        showEditDialog(item) {
            this.editItem = JSON.parse(JSON.stringify(item))
            this.titleForm = '编辑产品分类'
            this.editDialogVisible = true
        },
        async deleteEditDialog(item) {
            const confirmResult = await this.$confirm('此操作将删除该产品分类相关信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            // 如果用户确认删除，则返回值未字符串 confirm
            // 如果用户取消了删除，则返回值未字符串 cancel
            if (confirmResult !== 'confirm') {
                return this.$message.info('取消删除')
            }
            delCategoryProduct(item.id).then(response => {
                console.log('删除产品分类结果',response)
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                this.getCategoryList()
                this.$message.success(response.msg)
            })
        },
        editFun(){
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                if(this.titleForm==='添加产品分类'){
                    let data = JSON.parse(JSON.stringify(this.editItem))
                    console.log('执行'+this.titleForm,data)
                    addCategoryProduct(data).then(response => {
                        console.log('添加产品分类结果',response.data)
                        if(response.code!=200){
                            return this.$message.error('添加产品分类失败！')
                        }
                        this.$message.success('添加产品分类成功！')
                        this.getCategoryList()
                        this.editDialogVisible = false
                    })
                }else if(this.titleForm==='编辑产品分类'){
                    let data = JSON.parse(JSON.stringify(this.editItem))
                    console.log('执行'+this.titleForm,data)
                    updateCategoryProduct(this.editItem).then(response => {
                        console.log('编辑产品分类结果',response.data)
                        if(response.code!=200){
                            return this.$message.error('编辑产品分类失败！')
                        }
                        this.$message.success('编辑产品分类成功！')
                        this.getCategoryList()
                        this.editDialogVisible = false
                    })
                }
            })
        },
        getCategoryTree(cb) {
            categoryProductTree({}).then(response=>{
                if(response.code!=200)
                    return this.$message.error('获取产品分类树失败！')
                //console.log('获取产品分类树结果',response)
                this.categoryTree = response.data
                cb(this)
            })
        },
        nodeCategoryCascader(val){
            this.editItem.parent = val[val.length-1]
        },
        getParentNode(data,id) {
            var hasFound = false, // 表示是否有找到id值
                result = {name: ''}
            var fn = function (data) {
                if (Array.isArray(data) && !hasFound) { // 判断是否是数组并且没有的情况下，
                    data.forEach(item => {
                        if (item.id === id) { // 数据循环每个子项，并且判断子项下边是否有id值
                            result = item // 返回的结果等于每一项
                            hasFound = true // 并且找到id值
                        } else if (item.child) {
                            fn(item.child) // 递归调用下边的子项
                        }
                    })
                }
            }
            fn(data) // 调用一下
            // console.log('父节点',result,id)
            return result
        },
        getHeight(){
            if(this.total>0){
                this.treeTableHeight = window.innerHeight - 60 -40 -55 -62 -33 + 'px'
            }else{
                this.treeTableHeight = window.innerHeight - 60 -40 -55 -62 + 'px'
            }
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryInfo.pagenum=1
            this.getCategoryList()
        }
    },
    computed: {
        formRules: function(){
            let arr= {}
            arr.name = [
                { required: true, message: '请输入产品分类名称', trigger: 'blur' }
            ]
            return arr
        }
    },
    created(){
        this.getHeight()
        window.addEventListener('resize', this.getHeight)
        this.getCategoryTree(function (e) {
            e.getCategoryList()
        })
    },
    activated(){
        this.$refs.tableRef.doLayout()
    }
}
</script>

<style scoped>

</style>
